import './App.css';
import {StickerList} from "./StickerList.jsx";

export const App = () => {
  return (
    <div className="App">
        <StickerList/>
    </div>
  );
}
